module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/165-belgium-c59b3c1427f5d9b50f6403f147eb6abb.svg";